<template>
  <v-dialog v-model="dialogOpen" width="300" persistent>
    <v-card>
      <v-card-title>Edit Availability</v-card-title>
      <v-card-text>

        <v-row>
          <v-col>
            <v-text-field v-model="distance_from_exchange" label="Distance from exchange (m)" @blur="rounded" type="number" step="1" min="0" hide-details outlined dense></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="min_speed_available" label="Minimum speed available (mbps)" @change="matchMaxNumber" type="number" step="0.01" min="0" hide-details outlined dense></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="max_speed_available" label="Maximum speed available (mbps)" @change="matchMinNumber" type="number" step="0.01" :min="min_speed_available" hide-details outlined dense></v-text-field>
          </v-col>
        </v-row>

      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :disabled="telcoProvisioningLoading" :loading="telcoProvisioningLoading">SAVE</v-btn>
        <v-btn color="primary" small outlined @click="close">CLOSE</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapState,mapActions} from 'vuex';
  export default {
    props: ['dialogOpen'],
    data() {
      return {
        distance_from_exchange: 0,
        min_speed_available: 0,
        max_speed_available: 0,
      }
    },
    watch: {
      dialogOpen(open) {
        if(open){
          this.distance_from_exchange = this.telcoProvisioning.distance_from_exchange?this.telcoProvisioning.distance_from_exchange:0;
          this.min_speed_available = this.telcoProvisioning.min_speed_available?this.telcoProvisioning.min_speed_available:0;
          this.max_speed_available = this.telcoProvisioning.max_speed_available?this.telcoProvisioning.max_speed_available:0;
        }
      },
    },
    computed: {
      ...mapState('products',['currentProduct']),
      ...mapState('productTelco',['telcoProvisioning','telcoProvisioningLoading']),
    },
    methods: {
      ...mapActions('productTelco',['updateTelcoProvisioning']),

      matchMaxNumber(){
        if(parseFloat(this.max_speed_available)<parseFloat(this.min_speed_available)){
          this.max_speed_available = this.min_speed_available;
        }
      },

      matchMinNumber(){
        if(parseFloat(this.max_speed_available)<parseFloat(this.min_speed_available)){
          this.max_speed_available = this.min_speed_available;
        }
      },

      rounded(){
        this.distance_from_exchange = Math.round(this.distance_from_exchange);
      },

      async submit() {
        let postData = {
          distance_from_exchange: this.distance_from_exchange,
          min_speed_available: this.min_speed_available,
          max_speed_available: this.max_speed_available,
        }
        let success = await this.updateTelcoProvisioning({pid:this.currentProduct.id,data:postData});
        if(success){ this.close(); }
      },
      close() {
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>